const data = [
  ['',5, 10, 15, 20, 25, 30, 35],
  ['$1,650', 53.51, 52.80, 52.11, 51.43, 50.77, 50.13,49.50],
  ['$1,600', 51.89, 51.20, 50.53, 49.87, 49.23, 48.61,48.00],
  ['$1,550', 50.27, 49.60, 48.95, 48.31, 47.69, 47.09,46.50],
  ['$1,500', 48.65, 48.00, 47.37, 46.75, 46.15, 45.57,45.00],
  ['$1,450', 47.03, 46.40, 45.79, 45.19, 44.62, 44.05,43.50],
  ['$1,400', 45.41, 44.80, 44.21, 43.64, 43.08, 42.53,42.00],
  ['$1,350', 43.78, 43.20, 42.63, 42.08, 41.54, 41.01,40.50],
];

export default data;
